import { isEn } from "../i18n";

/**
 * Preço de um plano para o idioma atual.
 * Em inglês, usa o preço em US$ (preco_usd) quando ele foi definido no Admin;
 * caso contrário, mostra o preço original (normalmente em R$).
 */
export function planPrice(p) {
  if (!p) return { currency: "BRL", value: 0, symbol: "R$" };
  if (isEn() && Number(p.preco_usd) > 0) return { currency: "USD", value: Number(p.preco_usd), symbol: "$" };
  const currency = p.moeda || "BRL";
  const symbol = currency === "BRL" ? "R$" : currency === "USD" ? "$" : currency;
  return { currency, value: Number(p.preco || 0), symbol };
}

/** Texto curto do preço, ex.: "R$ 29" ou "$9". */
export function planPriceLabel(p, decimals = 0) {
  const { symbol, value } = planPrice(p);
  const n = value.toFixed(decimals);
  return symbol === "$" ? `$${n}` : `${symbol} ${n}`;
}
